import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {CartService} from "purchasing-shared/cart.service";
import {contextPath, fgURL} from "site";
import {purchasingEnabled} from "user";
import {Device} from "../device";
import {Enablement} from "../enablement";
import {EnablementCartItem} from "../enablement-cart-item";
import {EnablementPricingService} from "../enablement-pricing.service";

@Component({
	selector: "enablement-row",
	template: `
		<div class="deviceproductrow">
			<div class="deviceproductrow_content">

				<div class="deviceproductrow_info">
					<div class="deviceproductrow_type">
						<div class="deviceproductrow_typeheading">
							<div class="deviceproductrow_typename">
								{{enablement.description}}
							</div>
						</div>
					</div>

					<div class="deviceproductrow_status">
						<button *ngIf="hasAvSwPurchasePermission && !enablement.isOwned && !enablement.isUnredeemed && !enablementInCart" (click)="addEnablementToCart()" class="button button-primary">Buy Enablement</button>
						<button *ngIf="enablementInCart" class="button button-primary" disabled>Already In Cart</button>
						<a *ngIf="enablement.isOwned"
						   [routerLink]="['/install-enablements/', {deviceID: device.id, enablementID: enablement.id}]"
						   class="button button-primary">Install Enablement</a>
						<button *ngIf="enablement.isUnredeemed && !enablement.isOwned" (click)="redeemEnablement(enablement)" class="button button-primary">Redeem Enablement</button>
					</div>
				</div>

				<div class="deviceproductrow_warnings">
					<!-- TODO: WARNINGS HERE -->
				</div>
			</div>

			<form #redeemForm action="{{contextPath}}/api/enablements/redeem/" method="POST">
				<input type="hidden" name="enablementID" [value]="enablement.id" />
				<input type="hidden" name="deviceID" [value]="device.id" />
			</form>
		</div>
	`,
})
export class EnablementRowComponent implements OnInit {
	@Input() device: Device;
	@Input() enablement: Enablement;
	@Input() hasAvSwPurchasePermission: boolean;
	@Output() invalidCartAdd = new EventEmitter();

	readonly purchasingEnabled = purchasingEnabled;

	contextPath = contextPath;
	cartItem: EnablementCartItem;
	enablementInCart: boolean = false;

	@ViewChild("redeemForm") redeemForm: ElementRef;

	constructor(
		private cartService: CartService,
		private enablementService: EnablementPricingService,
	) {}

	ngOnInit() {
		this.enablementService.getEnablementPricingForDevices([this.device.id])
			.subscribe(enablementResponse => {
				for (let enablementDevice of enablementResponse) {
					for (let deviceEnablement of enablementDevice.enablements) {
						if (deviceEnablement.id === this.enablement.id) {
							this.enablement.price = deviceEnablement.price;
						}
					}
				}
			});
		this.cartItem = new EnablementCartItem({product: this.enablement, device: this.device});
		this.cartService.containsItem(this.cartItem).subscribe(
			(value) => {
				this.enablementInCart = value;
			}
		);

	}

	// ====================================================================================================
	// Cart
	// ====================================================================================================

	addEnablementToCart() {
		if (this.purchasingEnabled) {
			this.cartService.addItem(this.cartItem).subscribe(() => {
				window.location.href = `${fgURL}purchasing/cart`;
			});
		}
		else {
			this.invalidCartAdd.emit();
		}
	}

	// ====================================================================================================
	// Redeem
	// ====================================================================================================

	redeemEnablement() {
		this.redeemForm.nativeElement.submit();
	}
}
